import * as React from 'react';

import Image from 'components/atoms/Image';
import { ImageProps } from 'components/atoms/Image';
import { CardTypes } from 'defs/card-types';
import { CardTypeTypes } from 'types/Card';

export type PreviewImagePropsType = {
	type: CardTypeTypes;
	previewImage?: ImageProps;
};

const PreviewImage = ({ type, previewImage }: PreviewImagePropsType) => {
	const cardTypesWithoutImages: CardTypeTypes[] = [CardTypes.Tracking as any];

	if (previewImage && cardTypesWithoutImages.indexOf(type) === -1) {
		return <Image {...previewImage} />;
	}

	return <div />;
};

PreviewImage.displayName = 'Card(PreviewImage)';

export default PreviewImage;
